import React from "react";
import "./Our_Work.css";
import Common_Title from "../../common_components/common_title/Common_Title";

const Our_Work = () => {
  return (
    <section className="Our_Work">
      <div className="container">
        <div className="div1">
          <Common_Title
            boxText="Our Work "
            subText="Across Pune & Beyond "
            simpleText=" We have successfully completed projects in Viman Nagar (Eden Garden, Nico Garden,
Rohan Mithila), Dhayari, Nanded City (Sur & Kalashree Apartments), Vishrantwadi,
Alandi, Baner, Kharadi, as well as in Nashik, Mumbai, Thane, Satara, Sangamner, and
Bhigwan."
          />
        </div>




        {/* <div className="div2">
     <Common_Title
          boxText="Transform Your Space"
          subText="with Tech Interiors and Designers"
          simpleText=" Whether it’s a modern apartment, luxurious bungalow, commercial office, or retail
space, we bring creativity, precision, and functionality to every project."
        />
  </div> */}



      </div>
    </section>
  );
};

export default Our_Work;
